export default __webpack_public_path__ + "static/media/noticeBulletin.96a5cc67.png";